import Text from "@mobi/ds/components/Text"
import IconInovacao from "@mobi/ds/static/icons/filled/inovacao.svg"

import "./style.scss"

const AttentionCard = () => (
  <div className="attentionCard">
    <IconInovacao
      className="attentionCard__icon"
      aria-hidden="true"
      alt="Ícone de lâmpada acesa"
    />
    <div className="attentionCard__textWrapper">
      <Text as="h4" className="attentionCard__title">
        aproveite essas condições!
      </Text>
      <Text as="p" className="attentionCard__text">
        Para aproveitar essa oportunidade, solicite sua análise de crédito e{" "}
        <b>receba sua resposta em até 1 hora.</b>
      </Text>
    </div>
  </div>
)

export default AttentionCard
